import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import { useSelector } from "react-redux";
import Snackbar from "../../../Snackbar";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import LoadingButton from "../../Loading/LoadingButton";

const ShowLabelsCards = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"videoLinks":"");
const videoLinks =courseData?.videoLinks?JSON.parse(courseData?.videoLinks):[];

 const [animate, setAnimate] = useState(false);

 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"":"Course";

 useEffect(() => {
    // console.log(itemArr)
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



    
    
    
    
const handleBack=(e)=>{
  
    setLoader({status:true});
    
    history.goBack();
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"style={{}}><div  className="" style={{background:"#fff",padding:"5px",paddingTop:"20px",borderRadius:"25px"}}>

<h1 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> Phase 2:  <span className="coloredTextV1" > Add {TypeTitle} Labels </span> </h1>
<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",
        
    }}>

    

 <div align="left" className="itemCourseOuter" style={{ transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><MonitorPlay  size={32}  color="#958FDA"/></div> 

 <h2> Difficulty Level</h2> 
</div><div  className="set-expiry-card-bottom"style={{width:"265px"}} >
<div className="progress-bar-card-title">
  Completed : {courseData?.difficultyLabel?JSON.parse(courseData?.difficultyLabel)?.ID?"100%":"0%":"0%"}
   ({courseData?.difficultyLabel?JSON.parse(courseData?.difficultyLabel)?.ID?1:0:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner" style={{width:courseData?.difficultyLabel?JSON.parse(courseData?.difficultyLabel)?.ID?"100%":"0%":"0%"}}></div>
  </div>
  </div>
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","Set Course Difficulty Level As Beginner , Intermediate , Advanced Or create Your Own Type.")}
onMouseLeave={handleMouseLeave}
  onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/difficulty-level`)
     

   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
  </div>
<div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div></div>
 </div>   </div>
    

 <div align="left" className="itemCourseOuter" style={{transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 2s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><NotebookPen size={32}  color="#958FDA"/></div> 

 <h2>Set language</h2> 
</div><div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div className="progress-bar-card-title">
  Completed : {courseData?.languageLabel?JSON.parse(courseData?.languageLabel)?.ID?"100%":"0%":"0%"}
   ({courseData?.languageLabel?JSON.parse(courseData?.languageLabel)?.ID?1:0:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner" style={{width:courseData?.languageLabel?JSON.parse(courseData?.languageLabel)?.ID?"100%":"0%":"0%"}}></div>
  </div>
  </div>
  
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","Set Course Course Language As English , Hindi , Or create Your Own Type.")}
onMouseLeave={handleMouseLeave}
 
   
   onClick={()=>{ 
    
    history.push(`/apps/${AppToken}/create/language`)
  
   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
 </div>   </div>
    
{(courseData?.ID)?(courseData?.type=='course'||courseData?.type=='batch'||courseData?.type=='bundle')? <div align="left" className="itemCourseOuter" style={{transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><BookOpenCheck  size={32}  color="#958FDA"/></div> 

 <h2>{TypeTitle} Type</h2> 
</div><div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div className="progress-bar-card-title">
  Completed : {courseData?.typeLabel?JSON.parse(courseData?.typeLabel)?.ID?"100%":"0%":"0%"}
   ({courseData?.typeLabel?JSON.parse(courseData?.typeLabel)?.ID?1:0:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner" style={{width:courseData?.typeLabel?JSON.parse(courseData?.typeLabel)?.ID?"100%":"0%":"0%"}}></div>
  </div>
  </div>
 
 <button 
 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","Set Course Type As Online Blended , Live , Recorded, Offline Or create Your Own Type.")}
onMouseLeave={handleMouseLeave}
 
   
   onClick={()=>{ 
      
      
    history.push(`/apps/${AppToken}/create/type`)
  
   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
 </div>   </div>:"":""
}

    

 <div align="left" className="itemCourseOuter" style={{transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 4s ease, opacity 4s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><BookA  size={32}  color="#958FDA"/></div> 

 <h2>{TypeTitle} Status</h2> 
</div><div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div className="progress-bar-card-title">
  Completed : {courseData?.statusLabel?JSON.parse(courseData?.statusLabel)?.ID?"100%":"0%":"0%"}
   ({courseData?.statusLabel?JSON.parse(courseData?.statusLabel)?.ID?1:0:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner" style={{width:courseData?.statusLabel?JSON.parse(courseData?.statusLabel)?.ID?"100%":"0%":"0%"}}></div>
  </div>
  </div>
  
 <button
 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","Set Course Status As Trending , Recently Started , Coming Soon ,Archieved Or create Your Own Type.")}
onMouseLeave={handleMouseLeave}
   
   onClick={()=>{ 
    history.push(`/apps/${AppToken}/create/status`)
     
  
   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
 </div>   </div>
    

 <div align="left" className="itemCourseOuter" style={{transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 5s ease, opacity 5s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><TabletSmartphone GalleryHorizontal size={32}  color="#958FDA"/></div> 

 <h2>Student Limit </h2> 
</div><div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div className="progress-bar-card-title">
  Completed : {courseData?.maxStudents?JSON.parse(courseData?.maxStudents)?"100%":"0%":"0%"}
   ({courseData?.maxStudents?JSON.parse(courseData?.maxStudents)?1:0:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner" style={{width:courseData?.maxStudents?JSON.parse(courseData?.maxStudents)?"100%":"0%":"0%"}}></div>
  </div>
  </div>
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","Set Course Enrollment Limit Above Which Students May Not Enrol Or Buy Course.")}
onMouseLeave={handleMouseLeave}
 
   onClick={()=>{ 
    
    history.push(`/apps/${AppToken}/create/maximum-students`)
      

   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
 </div>   </div>
    


 <div align="left" className="itemCourseOuter" style={{transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 5s ease, opacity 5s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><TabletSmartphone GalleryHorizontal size={32}  color="#958FDA"/></div> 

 <h2>Add Instructors </h2> 
</div><div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div className="progress-bar-card-title">
  Completed : {courseData?.CourseMaxStudentAllowed&&courseData?.CourseMaxStudentAllowed!=""?"100%":"0%"}
   ({courseData?.CourseMaxStudentAllowed&&courseData?.CourseMaxStudentAllowed!=""?1:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner"
   style={{width:courseData?.CourseMaxStudentAllowed&&courseData?.CourseMaxStudentAllowed!=""?"100%":"0%"}}></div>
  </div>
  </div>
 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave}
 
   onClick={()=>{ 
    
    

   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" > + Add </span> </button>
 </div>   </div>
    


 <div align="left" className="itemCourseOuter" style={{transform: animate ? 'scale(1)' : 'scale(.5)',
        opacity: animate ? 1 : 0,
        transition: 'transform 5s ease, opacity 5s ease',marginBottom:"40px",height:"150px" ,border:"2px dashed  rgba(149, 143, 218, 1)"}}> 

<div  className="whatToDoNextItemCardInner" ><div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",
      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><TabletSmartphone GalleryHorizontal size={32}  color="#958FDA"/></div> 

 <h2> Set Start Date </h2> 
</div><div className="set-expiry-card-bottom"style={{width:"265px"}}>
<div className="progress-bar-card-title">
  Completed : {courseData?.CourseMaxStudentAllowed&&courseData?.CourseMaxStudentAllowed!=""?"100%":"0%"}
   ({courseData?.CourseMaxStudentAllowed&&courseData?.CourseMaxStudentAllowed!=""?1:0}/1)
<div className="progress-bar-card-outer">
  <div className="progress-bar-card-inner"
   style={{width:courseData?.CourseMaxStudentAllowed&&courseData?.CourseMaxStudentAllowed!=""?"100%":"0%"}}></div>
  </div>
  </div>
 
 <button 
 onMouseEnter={
  ()=>handleMouseEnter("#fff","#333","","Set Course Enrollment Limit Above Which Students May Not Enrol Or Buy Course.")}
onMouseLeave={handleMouseLeave}
 
   onClick={()=>{ 
    
    

   }}  
 className="selectThumbOuterRightButtonRemove"  type="submit"
 id="signupBtn"> <span className="" >Set It</span> </button>
 </div>   </div>
    



 </div>

 <div style={{height:"70px"}}></div>
  </div></div>
  
  <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/demo-videos`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/additional-info`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Go Next":"Go Next"} </button>
     
  </div>
</>}
    </>

}

export default ShowLabelsCards;


